import { Beer, LogOut } from "lucide-react";
import { createFileRoute, Link } from "@tanstack/react-router";

import { useProfile } from "@workspace/profile";
import { TenantSwitcher, useTenant } from "@workspace/tenant-context";
import { buttonVariants } from "@workspace/ui/components/button";
import { Label } from "@workspace/ui/components/label";
import RenderJson from "@workspace/ui/components/render-json";

import { PageLoadingFull } from "@/components/page-loading";

export const Route = createFileRoute("/_auth/_dashboard/profile/")({
	component: RouteComponent,
	pendingComponent: PageLoadingFull,
});

function RouteComponent() {
	const { user, tenant } = useProfile();
	const { appInstance, allTenants: availableTenants, setTenant } = useTenant();

	const nav = Route.useNavigate();

	return (
		<div>
			<div className="flex flex-col items-center justify-center gap-4">
				<Label className="text-2xl">Welcome, {user?.name}</Label>
				<Label>Instance: {appInstance?.label}</Label>
				<div>
					<TenantSwitcher
						setActiveTenant={async (t) => {
							if (t === tenant) return;

							await setTenant(t);

							await nav({
								to: "/",
							});
						}}
						tenant={tenant}
						tenants={[
							...availableTenants.map((t) => ({
								label: t.label,
								logo: Beer,
								plan: "Free",
								key: t.key,
								lastModified: t.lastModified,
								createdAt: t.createdAt,
							})),
						]}
					/>
				</div>
				<Link
					to="/logout"
					preload={false}
					className={buttonVariants({ variant: "outline" })}
				>
					<LogOut /> Log Out
				</Link>
				<RenderJson src={{ availableTenants, appInstance }} collapsed />
			</div>
			<RenderJson src={{ ...Route.useRouteContext() }} collapsed />
		</div>
	);
}
